<div id="wrapper">
  <div id="google_map">

    <agm-map *ngIf="tripBasicDetails" [maxZoom]="isOnGoingTrip?20:14" [zoom]="isOnGoingTrip?19:13"
             [latitude]="liveLocationDetails?liveLocationDetails.lat:destination.lat"
             [longitude]="liveLocationDetails?liveLocationDetails.lng:destination.lng">
      <agm-marker
        [latitude]="origin.lat"
        [longitude]="origin.lng"
        [iconUrl]="{ url:'assets/icons/map_start_pin.svg' , scaledSize: {height: 30, width: 30}}"
      >
        <agm-info-window [disableAutoPan]="false">
          <div class="text-center">
            <p>Trip Start</p>
            <p>{{tripBasicDetails.startLocationName ? tripBasicDetails.startLocationName : ''}}</p>
          </div>
        </agm-info-window>
      </agm-marker>
      <agm-marker
        [latitude]="liveLocationDetails?liveLocationDetails.lat:destination.lat"
        [longitude]="liveLocationDetails?liveLocationDetails.lng:destination.lng"
        [iconUrl]="{ url:isOnGoingTrip?'assets/icons/car.svg':'assets/icons/map_dest_pin.svg' , scaledSize: isOnGoingTrip?{height: 45, width: 45}:{height: 30, width: 30}}"
      >
        <agm-info-window [disableAutoPan]="false">
          <div class="text-center" *ngIf="!isOnGoingTrip">
            <p>Trip End</p>
            <p>{{tripBasicDetails.destinationName ? tripBasicDetails.destinationName : ''}}</p>
          </div>
          <div class="text-center" *ngIf="isOnGoingTrip">
            <div class="row d-flex justify-content-center">
              <div class="green-dot p-1"></div>
              <p>Live Location</p>
            </div>
            <p>{{liveLocationDetails && liveLocationDetails.locationDetails ? liveLocationDetails.locationDetails.toString() : ''}}</p>
            <p>{{ liveLocationDetails && liveLocationDetails.createdOn ? (liveLocationDetails.createdOn | date :'medium') : ''}}</p>
          </div>
        </agm-info-window>
      </agm-marker>

      <agm-marker

        *ngFor="let m of vehicleAlerts;"
        [latitude]="m.latitudeOnAlert"
        [longitude]="m.longitudeOnAlert"
        [label]="'VA'">
        <!--    [iconUrl]="{ url:'assets/icons/map_danger_pin.svg' , scaledSize: {height: 30, width: 30}}"-->
        <agm-info-window [disableAutoPan]="false">

          <div>
            <p class="text-center">Vehicle Alert</p>
            <p>Trouble Code: <b>{{m.troubleCode}}</b></p>
            <p>Error Description: <b>{{m.errorDesc}}</b></p>
            <p>Alert Fixed: <span class="text-success" *ngIf="m.alertFixed"><i class="fa fa-check"></i></span>
              <span class="text-danger" *ngIf="!m.alertFixed"><i class="fa fa-times p-2"></i></span></p>
          </div>

        </agm-info-window>
      </agm-marker>


      <agm-marker

        *ngFor="let m of drivingAlerts;"
        [latitude]="m.lat"
        [longitude]="m.long"
        [label]="m.label">
        <!--    [iconUrl]="{ url:'assets/icons/map_danger_pin.svg' , scaledSize: {height: 30, width: 30}}"-->
        <agm-info-window [disableAutoPan]="false" #infoWindow>

          <div>
            <p>Alert Type: <b>{{m.alert_Type}}</b></p>
            <p>Alert Value: <b>{{m.alert_value}}</b></p>
            <p>G Force: <b>{{m.g_force}}</b></p>
            <p>Time Interval: <b>{{m.time_interval}}</b></p>
          </div>

        </agm-info-window>
      </agm-marker>
      <agm-polyline [visible]="true" [strokeWeight]="3" [strokeColor]="'#000000'">
        <agm-polyline-point
          *ngFor="let coordinate of flightPlanCoordinates; let i=index"
          [latitude]="coordinate.lat"
          [longitude]="coordinate.lng">

        </agm-polyline-point>
      </agm-polyline>
    </agm-map>
  </div>

  <div id="over_map_2" class="bg-light">
    <b *ngIf="isOnGoingTrip"><b class="text-danger">*</b>Live trip data will be refreshed for every 2 minutes</b>
  </div>
</div>
<div class="col-12 p-0 m-0 mb-3">
  <mat-card>
    <div class="row">
      <div [ngClass]="isOnGoingTrip?'col-12 col-md-6':'col-12'" *ngIf="isOnGoingTrip">
        <mat-card-header>
          <mat-card-title>Live Location Details</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>Last Updated:
            <b>{{tripBasicDetails && tripBasicDetails.startDate ? (tripBasicDetails.startDate | date :'medium') : ''}}</b>
          </p>
          <p>Location:
            <b>{{liveLocationDetails && liveLocationDetails.locationDetails ? liveLocationDetails.locationDetails.toString() : ''}}</b>
          </p>
        </mat-card-content>
      </div>
      <div [ngClass]="isOnGoingTrip?'col-12 col-md-6 m-0 p-0 pl-3 pl-md-0 ':'col-12 pl-3'">
        <mat-card-header>
          <mat-card-title>Trip Details</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>Trip Vehicle:
            <b>{{tripBasicDetails?.tripVehicle?.vehicleBrand + '-' + tripBasicDetails?.tripVehicle?.vehicleModel + '-' + tripBasicDetails?.tripVehicle?.regNumber}}</b>
          </p>
          <p>Trip Started:
            <b>{{tripBasicDetails && tripBasicDetails.startDate ? (tripBasicDetails.startDate | date :'medium') : ''}}</b>
          </p> 
          <p>Start Location: <b>{{tripBasicDetails?.startLocationName || ''}}</b></p>
          <p>Trip Ended:
            <b>{{tripBasicDetails && tripBasicDetails.endDate ? (tripBasicDetails.endDate | date :'medium') : '-'}}</b>
          </p>
          <p>End location: <b>{{tripBasicDetails ? tripBasicDetails.destinationName : '-'}}</b></p>
        </mat-card-content>
      </div>
    </div>
    <hr>
    <mat-card-actions class="mat-action-bg">
      <div class="d-flex justify-content-around ">
        <div class="d-flex flex-column"><p><b>{{tripBasicDetails?.distanceCovered || '-'}}Km</b></p>
          <p>Trip Distance</p>
        </div>
        <div class="d-flex flex-column text-success"><p><b>{{tripBasicDetails?.safeKm || '-'}}Km</b></p>
          <p>Safe Km</p>
        </div>
        <div class="d-flex flex-column" *ngIf="tripBasicDetails">
          <p><b><span *ngIf=" getTripDuration()['hours']">{{getTripDuration()['hours']}}
            h </span><span *ngIf="getTripDuration()['minutes']">{{getTripDuration()['minutes']}}mins</span>
            <span *ngIf="!getTripDuration()['hours'] && !getTripDuration()['minutes']">-</span></b></p>
          <p>Trip Duration</p>
        </div>
        <div class="d-flex flex-column">
          <p><b>{{drivingAlerts.length}}</b></p>
          <p><span>Driving Alerts</span></p>
        </div>
      </div>
    </mat-card-actions>
  </mat-card>

</div>


